import { supabase } from '@/lib/supabaseClient';
import { TABLE_NAMES } from '@/lib/constants';

export interface RegistroPago {
  id_registro_pago?: string;
  id_deuda: string;
  fecha_pago: string; // Date string, e.g., YYYY-MM-DDTHH:MM:SSZ
  monto_pagado: number;
  metodo_pago?: string;
  referencia_pago?: string;
  notas?: string;
}

export const paymentService = {
  async getPaymentsByDebt(debtId: string) {
    const { data, error } = await supabase
      .from(TABLE_NAMES.REGISTRO_PAGO)
      .select('*')
      .eq('id_deuda', debtId);
    if (error) throw error;
    return data;
  },

  async getAllPayments() {
    const { data, error } = await supabase
      .from(TABLE_NAMES.REGISTRO_PAGO)
      .select('*');
    if (error) throw error;
    return data;
  },

  async createPayment(payment: RegistroPago) {
    const { data, error } = await supabase
      .from(TABLE_NAMES.REGISTRO_PAGO)
      .insert([payment])
      .select();
    if (error) throw error;
    return data[0];
  },

  async updatePayment(id: string, updates: Partial<RegistroPago>) {
    const { data, error } = await supabase
      .from(TABLE_NAMES.REGISTRO_PAGO)
      .update(updates)
      .eq('id_registro_pago', id)
      .select();
    if (error) throw error;
    return data[0];
  },

  async deletePayment(id: string) {
    const { error } = await supabase
      .from(TABLE_NAMES.REGISTRO_PAGO)
      .delete()
      .eq('id_registro_pago', id);
    if (error) throw error;
    return true;
  },
};